export const INSTALL_SDK_WIZARD_TYPE = "install-sdk";
